import Link from "next/link";
import Image from "next/image";
import { Clock, User, Tag } from 'lucide-react';

export default function PostCard({ post }) {
  const slug = "/" + post.slug;
  
  return (
    <Link href={`${slug}`} className="group">
      <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
        {/* Image Container */}
        <div className="relative h-56 overflow-hidden">
          <Image
            src={post.featured_image}
            alt={post.title}
            layout="fill"
            objectFit="cover"
            className="group-hover:scale-105 transition-transform duration-500"
          />
          {/* Category Tags */}
          <div className="absolute bottom-4 left-4 flex flex-wrap gap-2">
            {post.category_names.map((category, index) => (
              <span 
                key={index}
                className="px-3 py-1 bg-blue-600/90 backdrop-blur-sm text-white text-xs font-medium rounded-full"
              >
                {category}
              </span>
            ))}
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          {/* Title */}
          <h2 
            className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-300"
            dangerouslySetInnerHTML={{ __html: post.title }}
          />

          {/* Excerpt */}
          <p 
            className="text-gray-600 text-sm mb-4"
            dangerouslySetInnerHTML={{ __html: post.excerpt }}
          />

          {/* Author Info */}
          <div className="flex items-center text-sm text-gray-500">
            <div className="flex items-center">
              <User className="w-4 h-4 mr-2" />
              <span>{post.author}</span>
            </div>
            {/* Add additional metadata as needed */}
            {post.date && (
              <>
                <span className="mx-2">•</span>
                <div className="flex items-center">
                  <Clock className="w-4 h-4 mr-2" />
                  <span>{post.date}</span>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
}